import React, { useEffect, useState, useRef, useContext } from "react";
import { Text, StyleSheet, Animated } from "react-native";
import Colors from "../../constants/Colors";
import { Feather } from "@expo/vector-icons";
import GlobalContext from "../../context/Global";
import useNetworkHealth from "../../hooks/useNetworkHealth";

interface OfflineBannerProps {
  message?: string;
}

const OfflineBanner: React.FC<OfflineBannerProps> = ({ message }) => {
  const { isTablet } = useContext(GlobalContext);
  const [showBanner, setShowBanner] = useState(false);
  const slideAnim = useRef(new Animated.Value(-100)).current;

  const network = useNetworkHealth();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (network.isOffline) {
      timer = setTimeout(() => {
        setShowBanner(true);
        Animated.timing(slideAnim, {
          toValue: 0,
          duration: 500,
          useNativeDriver: true,
        }).start();
      }, 500);
    } else {
      Animated.timing(slideAnim, {
        toValue: -100,
        duration: 500,
        useNativeDriver: true,
      }).start(() => setShowBanner(false));
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [network.isOffline, network.latencyMs ?? null, slideAnim]);

  return (
    showBanner && (
      <Animated.View
        style={[
          styles.container,
          {
            transform: [{ translateY: slideAnim }],
          },
        ]}
      >
        <Text
          style={[
            styles.text,
            {
              fontSize: isTablet ? 16 : 12,
            },
          ]}
          numberOfLines={2}
        >
          {message}
        </Text>
        <Feather
          name="cloud-off"
          size={isTablet ? 24 : 18}
          color={Colors.base_colors_white}
          style={styles.icon}
        />
      </Animated.View>
    )
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.go_danger_500,
    padding: 10,
    paddingHorizontal: 24,
    width: "100%",
  },
  icon: {
    marginLeft: 10,
  },
  text: {
    color: Colors.base_colors_white,
    fontWeight: "bold",
  },
});

export default OfflineBanner;
